<template>
    <div>
        <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="goToSearchPage" />
        <mobile-info-page-tabs v-if="$breakpoint.smAndDown" v-model="mobileTabs" />
        <v-container fluid>
            <extra-service-breadcrumbs v-if="!$breakpoint.smAndDown" :search-request="searchRequest" />
            <v-row>
                <v-col v-show="!$breakpoint.smAndDown || ($breakpoint.smAndDown && mobileTabs === 0)" md="8">
                    <h1 v-if="product.info" class="text-h6">
                        {{ product.info.name }}
                    </h1>
                    <supplier-name-label v-if="isTO1" :supplier-name="product.supplierName" class="mb-1" />
                    <component
                        :is="!$breakpoint.smAndDown ? 'product-gallery' : 'product-gallery-mobile'"
                        :images-data="uniqueImages"
                    />
                    <template v-if="!$breakpoint.smAndDown">
                        <extra-service-offer-card
                            v-for="(offer, offerIndex) in product.offers"
                            :key="offer.offerKey"
                            :offer="offer"
                            :data-cy="`extra-service-offer-card-${offerIndex}`"
                            @images="images = [...images, ...$event]"
                            @description="setFullDescription"
                        />
                    </template>
                    <view-offers-button @show-offers="mobileTabs = 1" />
                    <div
                        v-if="(product.info && product.info.description) || fullDescription"
                        class="my-4"
                        v-html="fullDescription || product.info.description"
                    />
                </v-col>
                <v-col v-show="!$breakpoint.smAndDown || ($breakpoint.smAndDown && mobileTabs === 1)" md="4">
                    <extra-service-search-summary :search-request="searchRequest" />
                    <template v-if="$breakpoint.smAndDown">
                        <extra-service-offer-card
                            v-for="offer in product.offers"
                            :key="offer.offerKey"
                            :offer="offer"
                            :description="description"
                            @images="images = [...images, ...$event]"
                            @description="setFullDescription"
                        />
                    </template>
                    <div v-if="!$breakpoint.smAndDown" style="position: relative">
                        <client-only>
                            <extra-service-map
                                :city="city"
                                style="position: relative; max-height: 70vh; top: 0 !important"
                                class="disable-top"
                            />
                        </client-only>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <conditions-modal>
            <template v-slot:info>
                <extra-service-conditions-modal-info />
            </template>
        </conditions-modal>
        <extra-service-info-modal />
    </div>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import MobileInfoPageTabs from '~src/components/snippets/MobileInfoPageTabs.vue'
    import ConditionsModal from '~src/components/modals/ConditionsModal.vue'
    import ExtraServiceBreadcrumbs from '~src/components/extraServices/ExtraServiceBreadcrumbs.vue'
    import ExtraServiceOfferCard from '~src/components/extraServices/info/ExtraServiceOfferCard.vue'
    import ExtraServiceSearchSummary from '~src/components/extraServices/search/ExtraServiceSearchSummary.vue'
    import ExtraServiceMap from '~src/components/extraServices/search/ExtraServiceMap.vue'
    import ExtraServiceInfoModal from '~src/components/extraServices/info/ExtraServiceInfoModal.vue'
    import {ExtraServiceStoreMixin} from '@/mixins/ExtraServiceStoreMixin.vue'
    import ViewOffersButton from '~src/components/snippets/ViewOffersButton.vue'
    import ProductGallery from '~src/components/info/ProductGallery.vue'
    import ProductGalleryMobile from '~src/components/info/ProductGalleryMobile.vue'
    import {ExtraServicePageMixin} from '~src/components/extraServices/mixins/ExtraServicePageMixin.vue'
    import ExpiredOffersSnackbar from '~src/components/search/ExpiredOffersSnackbar.vue'
    import ExtraServiceConditionsModalInfo from '@/components/extraServices/snippets/ExtraServiceConditionsModalInfo.vue'
    import {SearchPageAuthMixin} from '@/components/mixins/SearchPageAuthMixin.vue'
    import {SearchPageMixin} from '@/components/mixins/SearchPageMixin.vue'
    import {InfoPageMixin} from '@/components/mixins/InfoPageMixin.vue'

    import SupplierNameLabel from '@/components/hotels/snippets/SupplierNameLabel.vue'
    import {useExtraServiceRuntimeData} from '~/composables/extra-service'

    @Component({
        components: {
            ExtraServiceConditionsModalInfo,
            ExpiredOffersSnackbar,
            ViewOffersButton,
            ExtraServiceOfferCard,
            ExtraServiceBreadcrumbs,
            MobileInfoPageTabs,
            ExtraServiceSearchSummary,
            ExtraServiceMap,
            ConditionsModal,
            ExtraServiceInfoModal,
            ProductGallery,
            ProductGalleryMobile,
            SupplierNameLabel,
        },
        async setup() {
            const route = useRoute()
            await useAsyncData(`extra-service-${route.query.cityId}`, async () => {
                await useExtraServiceRuntimeData(route)
                return true
            })
        },
    })
    export class ExtraServicePage extends mixins(
        ExtraServicePageMixin,
        ExtraServiceStoreMixin,
        SearchPageMixin,
        InfoPageMixin,
        SearchPageAuthMixin
    ) {
        fullDescription = null
        groupBy = 'serviceName'

        setFullDescription(serviceDescription) {
            this.fullDescription = serviceDescription
        }

        get uniqueImages() {
            return this.images.filter((v, i, a) => a.findIndex(t => t.url === v.url) === i)
        }

        get searchRequest() {
            return this.productStore.searchRequest
        }

        get city() {
            return this.productRuntimeStore.city
        }

        get description() {
            return this.product.info.description
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default ExtraServicePage
</script>

<style scoped lang="scss">
    .disable-top {
        top: 0 !important;
    }
</style>
